import React from 'react';
import Eyebrow from './Eyebrow';
import externalLinkProps from './externalLinkProps';

/**
 * `.offre-strip` — bandeau « bons plans canons ».
 *
 * Piège n°16 : `.offre-strip-cta` est stylé dans la maquette mais absent du
 * HTML — le CTA avait été retiré. Le composant sait le rendre si `cta` est
 * fourni ; par défaut il n'y en a pas, comme dans la maquette.
 */
const PromoStrip = ({ id, image, imageAlt, eyebrow, title, text, cta }) => {
  if (!title && !text) return null;

  return (
    <section className="offre-strip" id={id}>
      <div className="container offre-strip-inner">
        {image && (
          <div className="offre-strip-photo">
            <img src={image} alt={imageAlt || ''} width="110" height="110" loading="lazy" />
          </div>
        )}
        <div className="offre-strip-body">
          {eyebrow && <Eyebrow style={{ marginBottom: '8px' }}>{eyebrow}</Eyebrow>}
          {title && <h2>{title}</h2>}
          {text && <p>{text}</p>}
        </div>
        {cta && (
          <div className="offre-strip-cta">
            <a className="btn yellow" href={cta.href} {...externalLinkProps(cta.href)}>
              {cta.label}{' '}
              <span className="arr" aria-hidden="true">
                →
              </span>
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default PromoStrip;
